export default function Footer() {
  return (
    <></>
    // <div className="w-full grid grid-cols-3 md:grid-cols-5">
    //   <div className=" col-span-full">Sponsors:</div>
    // </div>
  );
}
